export function redirect(path:string) {
  location.href = path
}